import { useLingui } from '@lingui/react/macro'

import type { ClickButtonSchemaInput } from '@loc/server/interface/track/trackEventParams.common'

export interface SideBarData {
  key: string
  label: string
  icon: string
  href: string
  isNew?: boolean
  title?: string
  trackType?: ClickButtonSchemaInput['type']
}

export const sideBarKeys = {
  home: 'home',
  create: 'create',
  aiCover: 'aiCover',
  aiRap: 'aiRap',
  tts: 'tts',

  library: 'library',
}

export function useSideBarData() {
  const { t } = useLingui()

  const list: SideBarData[] = [
    {
      key: sideBarKeys.home,
      label: t`Home`,
      icon: 'i-cus--tad-home-bold',
      href: '/homepage',
      trackType: 'home',
    },
    {
      key: sideBarKeys.create,
      label: t`AI Music`,
      icon: 'i-cus--tad-smart-bold',
      href: '/ai-music-generator',
      trackType: 'AI Music',
    },
    {
      key: sideBarKeys.aiCover,
      label: t`AI Cover`,
      icon: 'i-cus--tad-ai-cover',
      href: '/ai-cover-generator',
      isNew: true,
      trackType: 'AI Cover',
    },
    // {
    //   key: sideBarKeys.aiRap,
    //   label: t`AI Rap`,
    //   icon: 'i-cus--tad-ai-rap',
    //   href: '/ai-rap-generator',
    //   isNew: true,
    //   trackType: 'AI Music',
    // },
    {
      key: sideBarKeys.tts,
      label: t`TTS`,
      title: t`Text to Speech`,
      icon: 'i-cus--tad-text-to-speech',
      href: '/text-to-speech',
      isNew: true,
      trackType: 'TTS',
    },
    {
      key: sideBarKeys.library,
      label: t`Library`,
      icon: 'i-cus--tad-library',
      href: '/ai-music-library',
      trackType: 'library',
    },
  ]

  return list
}
